import { useCallback, useMemo } from 'react';

import { useUser } from '@clerk/react';
import { ClerkMetadataKey } from '@this+that/utils';

import {
  buildSignatureBlock,
  resolveEmailSignatureForAccount,
  resolveSignatureBlockForAccount,
} from '../../utils/emailSignature';

export interface UseComposeSignatureBlockResult {
  signatureBlock: string;
  resolveSignatureBlock: (address: string | null | undefined) => string;
}

export function useComposeSignatureBlock(
  accountAddress?: string,
): UseComposeSignatureBlockResult {
  const { user } = useUser();
  const unsafeMetadata = user?.unsafeMetadata;
  const { enabled, html } = resolveEmailSignatureForAccount(
    unsafeMetadata,
    accountAddress,
  );

  const signatureBlock = useMemo(
    () => (enabled ? buildSignatureBlock(html) : ''),
    [enabled, html],
  );

  const storedKey = JSON.stringify(
    unsafeMetadata?.[ClerkMetadataKey.EMAIL_SIGNATURE] ?? null,
  );
  const resolveSignatureBlock = useCallback(
    (address: string | null | undefined) =>
      resolveSignatureBlockForAccount(
        { [ClerkMetadataKey.EMAIL_SIGNATURE]: JSON.parse(storedKey) },
        address,
      ),
    [storedKey],
  );

  return { signatureBlock, resolveSignatureBlock };
}
